import { Fatal } from './fatal/fatal.component';
import { Retentativa } from './retentativa/retentativa.component';

const ScreenError = {
  Fatal,
  Retentativa,
};

export default ScreenError;
